/** Normaliza nome de variável do template da Meta ({{Order Status}} → order_status). */
export function normalizarNomeVarTemplate(raw) {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
}

export function extrairPlaceholdersTemplate(texto) {
  const named = []
  const numbered = []
  const re = /\{\{\s*([^}]+)\s*\}\}/g
  let m
  while ((m = re.exec(String(texto || '')))) {
    const inner = String(m[1] || '').trim()
    if (!inner) continue
    if (/^\d+$/.test(inner)) numbered.push(parseInt(inner, 10))
    else named.push(inner)
  }
  return { named, numbered }
}

export function valorVarTemplate(chave, vars, fallback = '') {
  const mapa = {}
  Object.entries(vars || {}).forEach(([k, v]) => {
    mapa[normalizarNomeVarTemplate(k)] = String(v ?? '').trim()
  })
  const n = normalizarNomeVarTemplate(chave)
  return mapa[n] || mapa[chave] || String(fallback || '').trim()
}

export function montarComponentsTemplateMeta(metaComponents, vars, ordemPosicional = []) {
  const out = []
  const valorPos = (idx) => String(ordemPosicional[idx] || Object.values(vars || {})[idx] || '').trim() || '—'

  const paramsDeTexto = (texto) => {
    const { named, numbered } = extrairPlaceholdersTemplate(texto)
    if (named.length) {
      const vistos = new Set()
      return named.filter((n) => {
        const k = normalizarNomeVarTemplate(n)
        if (vistos.has(k)) return false
        vistos.add(k)
        return true
      }).map((n) => ({
        type: 'text',
        parameter_name: normalizarNomeVarTemplate(n),
        text: valorVarTemplate(n, vars, '—') || '—'
      }))
    }
    const qtd = numbered.length ? Math.max(...numbered) : 0
    if (qtd < 1) return []
    return Array.from({ length: qtd }, (_, i) => ({
      type: 'text',
      text: valorPos(i) || '—'
    }))
  }

  for (const raw of metaComponents || []) {
    const type = String(raw?.type || '').toUpperCase()
    if (type === 'BODY') {
      const parameters = paramsDeTexto(raw.text)
      if (parameters.length) out.push({ type: 'body', parameters })
    } else if (type === 'HEADER' && String(raw.format || '').toUpperCase() === 'TEXT') {
      const parameters = paramsDeTexto(raw.text)
      if (parameters.length) out.push({ type: 'header', parameters })
    }
  }
  return out
}

export function rotuloStatusWhatsApp(status) {
  const s = String(status || '').toLowerCase()
  if (s === 'read' || s === 'delivered') return { label: 'Recebido', classe: 'recebido' }
  if (s === 'failed' || s === 'warning') return { label: 'Falhou', classe: 'falhou' }
  if (s === 'sent' || s === 'pending' || s === 'queued' || s === 'accepted') {
    return { label: 'Enviado', classe: 'enviado' }
  }
  return { label: 'Não enviado', classe: 'vazio' }
}
